<template>
	<div class="deliverable-listing"
		:class="{ hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length) }">
		<b-modal centered hide-footer id="viewTitleModal" title="Enter View Title">
			<ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal" :namespace="namespace" />
		</b-modal>
		<b-modal centered hide-footer id="viewTitleUpdateModal" title="Enter View Title">
			<ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView"
				ref="refViewTitleModal" />
		</b-modal>
		<b-modal centered hide-footer id="createContactModal" title="New Contact" @shown="focusContactModal">
			<CreateContactModal ref="refContactModal" :namespace="namespace" />
		</b-modal>

		<b-modal hide-footer id="editContactModal" title="Update Contact" @shown="focusUpdateContactModal">
			<UpdateContactModal ref="refUpdateContactModal" :namespace="namespace" />
		</b-modal>

		<b-modal centered hide-footer id="createSpokespersonModal" title="New Spokesperson" @shown="focusSpokespersonModal">
			<CreateSpokespersonModal ref="refSpokespersonModal" :namespace="namespace" />
		</b-modal>
		<b-modal centered hide-footer id="createWhoModal" title="New Outlet / Contact" @shown="focusWhoModal">
			<CreateWhoModal ref="refWhoModal" :namespace="namespace" />
		</b-modal>

		<b-modal hide-footer id="editSpokespersonModal" title="Update Spokesperson" @shown="focusUpdateSpokespersonModal">
			<UpdateSpokespersonModal ref="refUpdateSpokespersonModal" :namespace="namespace" />
		</b-modal>
		<b-modal hide-footer id="editWhoModal" title="Update Outlet / Contact" @shown="focusUpdateWhoModal">
			<UpdateWhoModal ref="refUpdateWhoModal" :namespace="namespace" />
		</b-modal>

		<CreateCfContactModal v-show="currentFieldKey!=''" ref="refCfContactModal" :namespace="namespace" />
		<UpdateCfContactModal v-show="currentFieldKey!=''" ref="refUpdateCfContactModal" :namespace="namespace" />

		<b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable"
			@hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditModal :allContacts="allContacts" ref="refEditModal" :namespace="namespace" :tabIndex="tabIndex" />
		</b-modal>

		<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable"
			class="modal-edit-social-deliverable" @hide="editSocialModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditSocialModal ref="refEditSocialModal" :namespace="namespace" :tabIndex="tabIndex" />
		</b-modal>

		<b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
			title="Edit Organic Social Media Plan" class="modal-edit-deliverable" @hide="editOrganicSocialModalPlanHidden"
			@shown="pushRoute" @hidden="removeRoute">
			<EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
				:namespace="namespace" />
		</b-modal>

		<b-modal id="deleteDeliverableConfirmModal" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable"
			@cancel="onCancelRemoveDeliverable" ok-title="Yes, Delete">
			<p>Are you sure you want to delete this deliverable?</p>
		</b-modal>

		<!-- Mobile View Select Modal -->
		<b-modal id="headerViewSelectModal" hide-footer title="Views" @hidden="viewSelectModalHidden">
			<div id="header-view-select-modal" class="saved-views">
				<div class="view-select-title-header">
					<h4>Views</h4>
					<b-button class="d-block" variant="theme" title="Close View Popup" size="sm"
						@click="closeVuewSelectModal"><i class="fas fa-times"></i></b-button>
				</div>
				<div class="view-select-body">
					<a class="dropdown-item clear-view"
						@click="handleResetFilter(); $bvModal.hide('headerViewSelectModal');" href="#"
						v-show="activeView != '-1'">
						Clear View
						<span class="float-right">
							<i class="fas fa-cross text-primary"></i>
						</span>
					</a>
					<a class="dropdown-item update-view" @click="modalUpdateView" href="#" v-show="viewModalShowUpdateView">
						Update View
						<span class="float-right">
							<i class="far fa-edit text-primary"></i>
						</span>
					</a>
					<a class="dropdown-item save-view" @click="modalSaveView" href="#" v-show="viewModalShowCreateView">
						Save View
						<span class="float-right">
							<i class="fas fa-plus-circle text-primary"></i>
						</span>
					</a>
					<div class="new-view-title-area" v-if="showNewViewTitleArea">
						<div class="row">
							<div class="col-md-12">
								<h5>Save View</h5>
							</div>
						</div>
						<ViewTitleModal @setActiveView="setActiveView" :hasCancelButton="true"
							@cancelEdit="showNewViewTitleArea = false" :namespace="namespace" />
					</div>
					<div class="update-view-title-area" v-if="showUpdateViewTitleArea">
						<div class="row">
							<div class="col-md-12">
								<h5>Update View</h5>
							</div>
						</div>
						<ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView"
							:hasCancelButton="true" @cancelEdit="showUpdateViewTitleArea = false" :namespace="namespace" />
					</div>
					<div class="views__scroll" ref="views__scroll" v-if="!showNewViewTitleArea && !showUpdateViewTitleArea">
						<div :class="{ 'scroll__view__btns': !viewModalShowCreateView && !viewModalShowUpdateView }">
							<!-- Preset Views (Hardcode) -->
							<a class="dropdown-item" :class="{ active: activeView == userView.id }"
								@click="loadViewFromModal(userView, index)" :key="'userView' + index + 1 * Math.random()"
								v-for="(userView, index) in presetViewsMyWeek" href="#">
								<div class="preset-icon-wrap">
								</div>
								<span class="save-title">{{ userView.title }}</span>
							</a>

							<!-- User Views -->
							<a class="dropdown-item" :class="{ active: activeView == userView.id }"
								@click="loadViewFromModal(userView, index)" :key="'userView' + index + 1 * Math.random()"
								v-for="(userView, index) in userViewsDeliverable" href="#">
								<div class="remove-icon-wrap">
									<span class="remove-icon" @click.stop="removeView(userView.id)">
										<i class="fas fa-trash"></i>
									</span>
								</div>
								<span class="save-title">{{ userView.title }}</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</b-modal>



		<div v-if="myWeek" class="my__week__list">
			<div class="deliverable-header">
				<HeaderIcon :myWeek="myWeek" :namespace="namespace" />
				<span class="d-inline-block float-right saved-views-area"
					:class="[!showUpdateViewText ? 'pt-15' : '', activeView != '-1' ? 'saved-view-active' : '']">
					<div class="text-right" v-show="showUpdateViewText">
						<a href="#" @click="directUpdateView">Click here</a> to save updated view
					</div>
					<div class="btn-group float-right add-new__global_search sorting saved-views">
						<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle" type="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="updatePerfectScroll"
							v-if="!showCreateNewView">
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label truncate-text">{{ viewBtnLabel }}</span>
							<i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
							<i v-else v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Clear View"
								@click.stop="handleResetFilter()" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view" type="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label">Views</span>
							<i v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Save View"
								@click.stop="saveView" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<div class="dropdown-menu viewmenu-dropdown">
							<div>
								<a class="dropdown-item update-view" @click="updateView" href="#">
									Update View
									<span class="float-right">
										<i class="far fa-edit text-primary"></i>
									</span>
								</a>
								<a class="dropdown-item save-view" @click="saveView" href="#">
									Save View
									<span class="float-right">
										<i class="fas fa-plus-circle text-primary"></i>
									</span>
								</a>
								<perfect-scrollbar class="views__scroll" ref="views__scroll">
									<div>
										<!-- Preset Views (Hardcode) -->
										<a class="dropdown-item" :class="{ active: activeView == userView.id }"
											@click="loadView(userView, index)" :key="'userView' + index + 1 * Math.random()"
											v-for="(userView, index) in presetViewsMyWeek" href="#">
											<div class="preset-icon-wrap">
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>

										<!-- User Views -->
										<a class="dropdown-item" :class="{ active: activeView == userView.id }"
											@click="loadView(userView, index)" :key="'userView' + index + 1 * Math.random()"
											v-for="(userView, index) in userViewsDeliverable" href="#">
											<div class="remove-icon-wrap">
												<span class="remove-icon" @click.stop="removeView(userView.id)">
													<i class="fas fa-trash"></i>
												</span>
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>
									</div>
								</perfect-scrollbar>
							</div>
						</div>
					</div>
				</span>
				<!-- Expand / Collapse all button from the header -->
				<span class="d-inline-block float-right pt-15 mr-3 expand-all-area">
					<div v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
						class="ml-2 expand-grp cursor-pointer" @click="toggleStatusView(!expandAll)">
						<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': expandAll }"
							variant="theme" v-b-tooltip.hover title="Expand">
							<span class="text">Expand All </span>
							<span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
						</b-button>
						<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': !expandAll }"
							variant="theme" v-b-tooltip.hover title="Collapse">
							<span class="text">Collapse All</span>
							<span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
						</b-button>
					</div>
				</span>
			</div>
			<div class="mb-5" v-if="group.length" v-for="(group, index) in deliverablesArray" :key="index">
				<h2 class="deliverable-group-my-week">{{ _.startCase(index) }} ({{ deliverableCount[index] }})</h2>

				<!-- Start "My Week" Deliverable Loop -->
				<div class="deliverable-block"
					:class="(!userAbilities.editMediaCall || (deliverable && deliverable.permissions && deliverable.permissions.viewOnly)) ? 'read-only' : ''"
					v-for="(deliverable, index) in group" :key="'deliverable' + index">
					<div class="delv-block-resp"
						:class="isParentProjectOnHold(deliverable.project_id) ? 'parent-project-on-hold' : ''">
						<DuplicateMediaCallBtn :deliverableId='deliverable.id' :namespace="namespace"
							:deliverableTemplateId="deliverable.deliverable_template_id" />
						<div class="d-flex flex-row dbox-wrapper">
							<div class="dbox-left-side dleft-inner-wrap">

								<!-- START Social Top Row -->
								<div class="top-row" v-if="isSocialMedia(deliverable)"
									:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
									<div class="data-items">
										<span>
											{{ deliverableTypeTitle(deliverable.deliverable_template_id) }}
										</span>
									</div>

									<div class="data-items hide-mobile">
										<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
									</div>

									<div class="data-items hide-mobile social-series"
										v-if="deliverable.social_series.length > 0">
										<span class="department-label">SERIES: </span>
										<span class="department-title">{{ getSeriesNameByDeliverable(deliverable) }}</span>
									</div>
									<div class="data-items hide-mobile">
										<span>POST DATE:</span>
										<span class="post-date-value">{{ displaySocialPublishDate(deliverable.publish_date)
										}}</span>
									</div>
									<div class="data-items social-status hide-mobile">
										<span>STATUS</span>
									</div>
								</div>
								<!-- END Social Top Row -->

								<div class="top-row" v-else
									:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
									<DeliverableDropdown :deliverable="deliverable" :deliverableTypes="deliverableTypes"
										:classNames="''" />
									<template>
										<div class="data-items hide-mobile">
											<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
										</div>
										<div class="data-items hide-mobile" v-if="hasPriorityField(deliverable)">
											<span class="">PRIORITY: </span>
											<span v-b-tooltip.hover title="Priority" class="listing-priority"
												@click="setPriority(deliverable, false)"
												:class="'listing-priority-del-' + deliverable.id">
												<vue-star-rate
													:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
													:maxIcon="5" :iconHeight="17" :iconWidth="17" :hasCounter="false"
													:key="'del-rating-' + Math.random() + deliverable.id"
													iconColor="#ffffff" iconColorHover="#ffffff"
													iconShape="circle"></vue-star-rate>
											</span>
										</div>
										<template v-if="showAltStartEndDate(deliverable)">
											<div class="data-items hide-mobile">
												<span class="">START DATE:</span>
												<template v-if="calculateStartDate(deliverable)">
													{{ calculateStartDate(deliverable) | moment("DD MMM, YYYY") }}
												</template>
												<template v-else>
													No Date
												</template>
											</div>
											<div class="data-items hide-mobile">
												<span class="">END DATE:</span>
												<template v-if="calculateEndDate(deliverable)">
													{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
												</template>
												<template v-else>
													No Date
												</template>
											</div>
										</template>
										<template v-else>
											<div class="data-items hide-mobile">
												<span class="">STARTED:</span>
												{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
											</div>
											<div v-if="deliverable.all_completed" class="data-items hide-mobile">
												<span class="">COMPLETED:</span>
												{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
											</div>
											<div v-else class="data-items hide-mobile">
												<span class="">LAST MODIFIED:</span>
												{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
											</div>
										</template>
									</template>
								</div>
								<DeliverableTypeIcon 
									:deliverableTypeId="deliverable.deliverable_template_id"
									:deliverableProject="deliverable.project_id"
									:namespace="namespace" />
								<div class="row mobile-deli-info">
									<div class="data-items deliverable-priority" v-if="hasPriorityField(deliverable)">
										<span class="text-primary">PRIORITY: </span>
										<span v-b-tooltip.hover title="Priority" class="listing-priority"
											@click="setPriority(deliverable, true)"
											:class="'listing-priority-del-' + deliverable.id">
											<vue-star-rate
												:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
												:maxIcon="5"
												:iconHeight="17"
												:iconWidth="17"
												:hasCounter="false"
												:key="'del-rating-'+Math.random()+deliverable.id"
												iconColor="var(--wf-primary)"
												iconColorHover="var(--wf-primary)"
												iconShape="circle"
											></vue-star-rate>
										</span>
									</div>
									<template v-if="showAltStartEndDate(deliverable)">
										<div class="data-items deliverable-start">
											<span class="text-primary">START DATE:</span>
											<template v-if="calculateStartDate(deliverable)">
												{{ calculateStartDate(deliverable) | moment("DD MMM, YYYY") }}
											</template>
											<template v-else>
												No Date
											</template>
										</div>
										<div class="data-items deliverable-end">
											<span class="text-primary">END DATE:</span>
											<template v-if="calculateEndDate(deliverable)">
												{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
											</template>
											<template v-else>
												No Date
											</template>
										</div>
									</template>
									<template v-else>
										<div class="data-items deliverable-start">
											<span class="text-primary">STARTED:</span>
											{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
										<div v-if="deliverable.all_completed" class="data-items">
											<span class="text-primary deliverable-end">COMPLETED:</span>
											{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
										<div v-else class="data-items deliverable-last-mod">
											<span class="text-primary">LAST MODIFIED:</span>
											{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
									</template>
									<div class="data-items no-padding deliverable-tags">
										<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
											:namespace="namespace" @tag-created="updateDeliverableTags" />
									</div>
									<div class="data-items deliverable-project">
										<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
									</div>
								</div>
								<div class="row listing-row">
									<div :class="` ${deliverable.total_unread_messages_in_conversation > 0 ? 'col-md-7' : 'col-md-8 titles '} breakpoint__fix ${isSocialMedia(deliverable) ? 'social-titles' : ''} ${isSeriesMaster(deliverable) ? 'series-master' : ''} `" :style="infoColStyle(deliverable)">
										<div class="inside-list department--wrap--new" v-if="showDepartment(deliverable)">
											<DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
										</div>
										<div :class="`deliverable-title edit-d-title ${showDepartment(deliverable) ? '' : 'no-depart'}`"
											@click="showModalFn(deliverable, false)">
											{{ deliverable.title || 'Click to set...' }}
										</div>
										<div class="mobile-task-expand-button-area">
											<div class="mobile-task-exp-btn">
												<CollapseTaskBtn :deliverable="deliverable" :index="deliverable.id"
													:expandAll="expandAll" />
											</div>
										</div>
										<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable()"
											@click.stop="deleteDeliverableClick(deliverable)" class="delete-bar">
											<span><i class="fas fa-trash"></i></span>
										</div>
									</div>
									<div v-if="!isMobile() && isSocialMedia(deliverable)"
										class="col-md-4 infos publish-status">
										<div class="d-flex flex-row"
											:style="getPublishStatusStyle(deliverable.publish_status)">
											<PublishStatusListLabel :deliverable="deliverable" :namespace="namespace" />
										</div>
									</div>
									<div 
										v-if="!isMobile() &&
										!isSocialMedia(deliverable) &&
										getSystemSetting('is_chat_enabled') &&
										deliverable.total_unread_messages_in_conversation > 0" 
										class="col-md-1 infos titles" 
										@click="showModalFn(deliverable, true)">
										<div class="d-flex flex-row">
											<ListMessageCounter :deliverable="deliverable" />
										</div>
									</div>
									<div v-if="!isMobile() && !isSocialMedia(deliverable)" class="col-md-4 infos">
										<div class="d-flex flex-row">
											<DeliverableListCoordinators 
												v-if="showInfoCol(deliverable) && getSystemSetting('media_call__show_owner')"
												class="deliverable-list-coordinators" :deliverable="deliverable"
												:namespace="namespace" />
											<DeliverableListContacts v-if="showInfoCol(deliverable)"
												class="deliverable-list-contacts" :deliverable="deliverable"
												:namespace="namespace" />
											<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
												:namespace="namespace" @tag-created="updateDeliverableTags" />
											<DeliverableStatusOverview :deliverable="deliverable" :namespace="namespace" />
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<div>
											<b-collapse :visible="expandAll"
												:id="'task-listing-collapse-' + deliverable.id">
												<div v-if="isMobile()" class="col-md-12 infos responsive-infos">
													<div class="d-flex flex-row">
													</div>
												</div>
												<TaskFieldLabels :fullDeliverables="deliverablesArray"
													:tasks="deliverable.tasks" :deliverableId="deliverable.id"
													:deliverable="deliverable" :namespace="namespace" />
												<TaskFields :fullDeliverables="deliverablesArray" :deliverable="deliverable"
													:deliverableId="deliverable.id" :myWeek="true"
													:tasks="deliverable.tasks" :users="deliverable.users"
													:namespace="namespace" />
											</b-collapse>
										</div>
									</div>
								</div>
							</div>

							<div class="dbox-right-side dright-inner-wrap">
								<CollapseTaskBtn :deliverable="deliverable" :index="deliverable.id" :expandAll="expandAll"
									:namespace="namespace" />
							</div>
						</div>
					</div>
				</div>
				<!-- End "My Week" Deliverable Loop -->

			</div>
			<div class="mb-5" v-if="!hasMyWeek()">
				<h2>No tasks</h2>
			</div>
			<div class="pagination-wrapper">
				<pagination :data="userDeliverablesPaginationData" @pagination-change-page="onChangePage" :limit="5">
				</pagination>
			</div>
		</div>
		<div v-if="!myWeek">
			<div class="deliverable-header">
				<HeaderIcon
					:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
					:totalOutletCount="this.outletCount ? this.outletCount : 0" :myWeek="myWeek" :namespace="namespace" />
				<span class="d-inline-block float-right saved-views-area"
					:class="[!showUpdateViewText ? 'pt-15' : '', activeView != '-1' ? 'saved-view-active' : '']">
					<div class="text-right" v-show="showUpdateViewText">
						<a href="#" @click="directUpdateView">Click here</a> to save updated view
					</div>
					<div class="btn-group float-right add-new__global_search sorting saved-views">
						<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle" type="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="updatePerfectScroll"
							v-if="!showCreateNewView">
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label truncate-text">{{ viewBtnLabel }}</span>
							<i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
							<i v-else v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Clear View"
								@click.stop="handleResetFilter()" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view" type="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
							<span class="updated-view" v-if="showUpdateViewText"></span>
							<span class="mr-3 view__label">Views</span>
							<i v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Save View"
								@click.stop="saveView" class="fas fa-fw fa-eye text-primary float-right"></i>
						</button>
						<div class="dropdown-menu viewmenu-dropdown">
							<div>
								<a class="dropdown-item update-view" @click="updateView" href="#">
									Update View
									<span class="float-right">
										<i class="far fa-edit text-primary"></i>
									</span>
								</a>
								<a class="dropdown-item save-view" @click="saveView" href="#">
									Save View
									<span class="float-right">
										<i class="fas fa-plus-circle text-primary"></i>
									</span>
								</a>
								<perfect-scrollbar class="views__scroll" ref="views__scroll">
									<div>
										<!-- Preset Views (Hardcode) -->
										<a class="dropdown-item" :class="{ active: activeView == userView.id }"
											@click="loadView(userView, index)" :key="'userView' + index + 1 * Math.random()"
											v-for="(userView, index) in presetViewsDashboard" href="#">
											<div class="preset-icon-wrap">
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>

										<!-- User Views -->
										<a class="dropdown-item" :class="{ active: activeView == userView.id }"
											@click="loadView(userView, index)" :key="'userView' + index + 1 * Math.random()"
											v-for="(userView, index) in userViewsDeliverable" href="#">
											<div class="remove-icon-wrap">
												<span class="remove-icon" @click.stop="removeView(userView.id)">
													<i class="fas fa-trash"></i>
												</span>
											</div>
											<span class="save-title">{{ userView.title }}</span>
										</a>
									</div>
								</perfect-scrollbar>
							</div>
						</div>
					</div>
				</span>
				<!-- Expand / Collapse all button from the header -->
				<span class="d-inline-block float-right pt-15 mr-3 expand-all-area">
					<div v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
						class="ml-2 expand-grp cursor-pointer" @click="toggleStatusView(!expandAll)">
						<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': expandAll }"
							variant="theme" v-b-tooltip.hover title="Expand">
							<span class="text">Expand All </span>
							<span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
						</b-button>
						<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': !expandAll }"
							variant="theme" v-b-tooltip.hover title="Collapse">
							<span class="text">Collapse All</span>
							<span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
						</b-button>
					</div>
				</span>
			</div>

			<!-- Start Dashboard Deliverable Loop -->
			<div class="deliverable-block"
				:class="(!userAbilities.editMediaCall || (deliverable && deliverable.permissions && deliverable.permissions.viewOnly)) ? 'read-only' : ''"
				v-for="(deliverable, index) in deliverablesArray" v-if="index != 'totalOutlets'"
				:key="'deliverable' + index">
				<div class="delv-block-resp"
					:class="isParentProjectOnHold(deliverable.project_id) ? 'parent-project-on-hold' : ''">
					<DuplicateMediaCallBtn :deliverableId='deliverable.id' :namespace="namespace"
						:deliverableTemplateId="deliverable.deliverable_template_id" />
					<div class="d-flex flex-row dbox-wrapper">
						<div class="dbox-left-side dleft-inner-wrap">

							<!-- START Social Top Row -->
							<div class="top-row" v-if="isSocialMedia(deliverable)"
								:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
								<div class="data-items">
									<span>
										{{ deliverableTypeTitle(deliverable.deliverable_template_id) }}
									</span>
								</div>
								<div class="data-items deliverable-project">
									<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
								</div>
								<div class="data-items hide-mobile social-series"
									v-if="deliverable.social_series.length > 0">
									<span class="department-label">SERIES: </span>
									<span class="department-title">{{ getSeriesNameByDeliverable(deliverable) }}</span>
								</div>
								<div class="data-items hide-mobile">
									<span>POST DATE:</span>
									<span class="post-date-value">{{ displaySocialPublishDate(deliverable.publish_date)
									}}</span>
								</div>
								<div class="data-items social-status hide-mobile">
									<span>STATUS</span>
								</div>
							</div>
							<!-- END Social Top Row -->

							<div class="top-row" v-else
								:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
								<DeliverableDropdown :deliverable="deliverable" :deliverableTypes="deliverableTypes"
									:classNames="''" />
								<template>
									<div class="data-items hide-mobile">
										<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
									</div>
									<div class="data-items hide-mobile" v-if="hasPriorityField(deliverable)">
										<span class="">PRIORITY: </span>
										<span v-b-tooltip.hover title="Priority" class="listing-priority"
											@click="setPriority(deliverable, false)"
											:class="'listing-priority-del-' + deliverable.id">
											<vue-star-rate
												:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
												:maxIcon="5" :iconHeight="17" :iconWidth="17" :hasCounter="false"
												:key="'del-rating-' + Math.random() + deliverable.id" iconColor="#ffffff"
												iconColorHover="#ffffff" iconShape="circle"></vue-star-rate>
										</span>
									</div>
									<template v-if="showAltStartEndDate(deliverable)">
										<div class="data-items hide-mobile">
											<span class="">START DATE:</span>
											<template v-if="calculateStartDate(deliverable)">
												{{ calculateStartDate(deliverable) | moment("DD MMM, YYYY") }}
											</template>
											<template v-else>
												No Date
											</template>
										</div>

										<div class="data-items hide-mobile">
											<span class="">END DATE:</span>
											<template v-if="calculateEndDate(deliverable)">
												{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
											</template>
											<template v-else>
												No Date
											</template>
										</div>
									</template>
									<template v-else>
										<div class="data-items hide-mobile">
											<span class="">STARTED:</span>
											{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
										<div v-if="deliverable.all_completed" class="data-items hide-mobile">
											<span class="">COMPLETED:</span>
											{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
										<div v-else class="data-items hide-mobile">
											<span class="">LAST MODIFIED:</span>
											{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
										</div>
									</template>
								</template>
							</div>
							<DeliverableTypeIcon 
							:deliverableTypeId="deliverable.deliverable_template_id"
							:deliverableProject="deliverable.project_id" />
							<div class="row mobile-deli-info">
								<div class="data-items deliverable-priority" v-if="hasPriorityField(deliverable)">
									<span class="text-primary">PRIORITY: </span>
									<span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable, true)" :class="'listing-priority-del-'+deliverable.id">
										<vue-star-rate
											:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
											:maxIcon="5"
											:iconHeight="17"
											:iconWidth="17"
											:hasCounter="false"
											:key="'del-rating-'+Math.random()+deliverable.id"
											iconColor="var(--wf-primary)"
											iconColorHover="var(--wf-primary)"
											iconShape="circle"
										></vue-star-rate>
									</span>
								</div>
								<template v-if="showAltStartEndDate(deliverable)">
									<div class="data-items deliverable-start"
										v-for="(field, index) in _.filter(deliverable.customFields, { field_key: 'start_date' })"
										:key="index">
										<span class="text-primary">START DATE:</span>
										{{ field.value | moment("DD MMM, YYYY") }}
									</div>
									<div class="data-items deliverable-start"
										v-if="_.filter(deliverable.customFields, { field_key: 'start_date' }).length == 0">
										<span class="text-primary">START DATE:</span>
										No Date
									</div>
									<div class="data-items deliverable-end">
										<span class="text-primary">END DATE:</span>
										<template v-if="calculateEndDate(deliverable)">
											{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
										</template>
										<template v-else>
											No Date
										</template>
									</div>
								</template>
								<template v-else>
									<div class="data-items">
										<span class="text-primary deliverable-start">STARTED:</span>
										{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
									</div>
									<div v-if="deliverable.all_completed" class="data-items deliverable-completed">
										<span class="text-primary">COMPLETED:</span>
										{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
									</div>
									<div v-else class="data-items deliverable-last-mod">
										<span class="text-primary">LAST MODIFIED:</span>
										{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
									</div>
								</template>
								<div class="data-items no-padding deliverable-tags">
									<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
										:namespace="namespace" @tag-created="updateDeliverableTags" />
								</div>
								<div class="data-items deliverable-project">
									<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
								</div>
							</div>
							<div class="row listing-row">
								<div :class="` ${deliverable.total_unread_messages_in_conversation > 0 ? 'col-md-7' : 'col-md-8 titles '} breakpoint__fix ${isSocialMedia(deliverable) ? 'social-titles' : ''}`" :style="infoColStyle(deliverable)">
									<div class="inside-list department--wrap--new" v-if="showDepartment(deliverable)">
										<DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
									</div>
									<div :class="`deliverable-title edit-d-title ${showDepartment(deliverable) ? '' : 'no-depart'}`"
										@click="showModalFn(deliverable, false)">
										{{ deliverable.title }}
									</div>
									<div class="mobile-task-expand-button-area">
										<div class="mobile-task-exp-btn">
											<CollapseTaskBtn :deliverable="deliverable" :index="index"
												:expandAll="expandAll" :namespace="namespace" />
										</div>
									</div>
									<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable()"
										@click.stop="deleteDeliverableClick(deliverable)"
										:class="`delete-bar ${deliverable.id == stripRemoveDeliverableId ? 'hovered' : ''}`"
										v-click-outside="deleteDeliverableClickOutside(deliverable.id)">
										<span><i class="fas fa-trash"></i></span>
									</div>
								</div>
								<div v-if="!isMobile() && isSocialMedia(deliverable)" class="col-md-4 infos publish-status">
									<div class="d-flex flex-row" :style="getPublishStatusStyle(deliverable.publish_status)">
										<PublishStatusListLabel :deliverable="deliverable" :namespace="namespace" />
									</div>
								</div>
								<div 
									v-if="!isMobile() &&
									!isSocialMedia(deliverable) &&
									getSystemSetting('is_chat_enabled') &&
									deliverable.total_unread_messages_in_conversation > 0" 
									class="col-md-1 infos titles" 
									@click="showModalFn(deliverable, true)">
									<div class="d-flex flex-row">
										<ListMessageCounter :deliverable="deliverable" />
									</div>
								</div>
								<div v-if="!isMobile() && !isSocialMedia(deliverable)" class="col-md-4 infos">

									<div class="d-flex flex-row">
										<DeliverableListCoordinators 
											v-if="showInfoCol(deliverable) && getSystemSetting('media_call__show_owner')"
											class="deliverable-list-coordinators" :deliverable="deliverable"
											:namespace="namespace" />

										<DeliverableListContacts v-if="showInfoCol(deliverable)"
											class="deliverable-list-contacts" :deliverable="deliverable"
											:namespace="namespace" />

										<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
											:namespace="namespace" @tag-created="updateDeliverableTags" />

										<DeliverableStatusOverview :deliverable="deliverable" :namespace="namespace" />
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div>
										<b-collapse :visible="expandAll" :id="'task-listing-collapse-' + index">
											<div v-if="isMobile()" class="col-md-6 infos responsive-infos">
												<div class="d-flex flex-row">
												</div>
											</div>
											<TaskFieldLabels :fullDeliverables="deliverablesArray"
												:tasks="deliverable.tasks" :deliverableId="deliverable.id"
												:deliverable="deliverable" :namespace="namespace" />
											<TaskFields :fullDeliverables="deliverablesArray" :deliverable="deliverable"
												:deliverableId="deliverable.id" :myWeek="false" :tasks="deliverable.tasks"
												:users="deliverable.users" :namespace="namespace" />
										</b-collapse>
									</div>
								</div>
							</div>
						</div>
						<div class="dbox-right-side dright-inner-wrap">
							<CollapseTaskBtn :deliverable="deliverable" :expandAll="expandAll" :index="index"
								:namespace="namespace" />
						</div>
					</div>
				</div>
			</div>
			<!-- End Dashboard Deliverable Loop -->

			<div class="pagination-wrapper" v-show="!myWeek && !inProject">
				<pagination :data="allDeliverablesPaginationData" @pagination-change-page="onChangePage"
					:limit="isMobile() ? 3 : 5" :size="isMobile() ? 'small' : 'default'"></pagination>
			</div>

			<div class="pagination-wrapper" v-show="inProject">
				<pagination :data="allProjectDeliverablesPaginationData" @pagination-change-page="onChangePage"
					:limit="isMobile() ? 3 : 5" :size="isMobile() ? 'small' : 'default'"></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditModal from "./EditModal";
import EditSocialModal from "./EditSocialModal.vue";
import EditOrganicSocialMediaPlanModal from "./EditOrganicSocialMediaPlanModal";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import vueStarRate from "vue-js-star-rating";

import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import DeliverableStatusOverview from './DeliverableStatusOverview';

import CreateCfContactModal from "./CreateCfContactModal";
import UpdateCfContactModal from "./EditCfContactModal";
import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";

import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import SocialDeliverableCampaigns from "./SocialDeliverableCampaigns";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableDropdown from "./DeliverableDropdown";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import DeliverableCustomFields from '../common/DeliverableCustomField';
import HeaderIcon from './HeaderIcon';
import ListMessageCounter from "./ListMessageCounter";
import PublishStatusListLabel from "./PublishStatusListLabel";
import toast from '../../toast';

export default {
	props: ["myWeek", "filterQuery", "expandAll", "namespace", "inProject"],
	data() {
		return {
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			tabIndex: 0,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,

			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,
			tabIndex: 0,
			whiteColor: this.$store.state.colorThemeVariables.scssVariables.secondary,
		}
	},
	created() {
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
		this.fetchSocialSeries();
		this.fetchSocialCampaigns();
		this.fetchUserManageSocialCampaigns();
		/*
		* PublishStatusListLabel needs SystemSettings.actions dropdown,
		* calling from list created to avoid multiple api calls
		*/
		this.fetchSystemSettings();
	},
	components: {
		EditModal,
		EditSocialModal,
		EditOrganicSocialMediaPlanModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		CreateCfContactModal,
		UpdateCfContactModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		DeliverableDropdown,
		ViewTitleModal,
		vueStarRate,
		DeliverableProjects,
		SocialDeliverableCampaigns,
		DeliverableTypeIcon,
		DeliverableStatusOverview,
		DeliverableCustomFields,
		HeaderIcon,
		ListMessageCounter,
		PublishStatusListLabel,
	},
	computed: {
		...mapGetters([
			"systemSettings",
			"dataLoading",
			"getSystemSetting",
			"userAbilities",
			"deliverableTypes",
			"currentFieldKey",
		]),
		...mapState({
			allDeliverables (state, getters) {
			  return getters[this.namespace + 'allDeliverables']
			},
			allDeliverablesPaginationData (state, getters) {
			  return getters[this.namespace + 'allDeliverablesPaginationData']
			},
			userDeliverablesPaginationData (state, getters) {
			  return getters[this.namespace + 'userDeliverablesPaginationData']
			},
			allProjectDeliverablesPaginationData (state, getters) {
			  return getters[this.namespace + 'allProjectDeliverablesPaginationData']
			},
			allTags (state, getters) {
			  return getters[this.namespace + 'allTags']
			},
			allContacts (state, getters) {
			  return getters[this.namespace + 'allContacts']
			},
			deliverableDetail (state, getters) {
			  return getters[this.namespace + 'deliverableDetail']
			},
			allDepartments (state, getters) {
			  return getters[this.namespace + 'allDepartments']
			},
			allSubjects (state, getters) {
			  return getters[this.namespace + 'allSubjects']
			},
			userDeliverables (state, getters) {
			  return getters[this.namespace + 'userDeliverables']
			},
			projectDeliverables (state, getters) {
			  return getters[this.namespace + 'projectDeliverables']
			},
			unGroupedUserDeliverables (state, getters) {
			  return getters[this.namespace + 'unGroupedUserDeliverables']
			},
			deliverableFilter (state, getters) {
			  return getters[this.namespace + 'deliverableFilter']
			},
			myWeekDeliverableFilter (state, getters) {
			  return getters[this.namespace + 'myWeekDeliverableFilter']
			},
			outletCount (state, getters) {
			  return getters[this.namespace + 'outletCount']
			},
			userViews (state, getters) {
			  return getters[this.namespace + 'userViews']
			},
			userManageProjects (state, getters) {
			  return getters[this.namespace + 'userManageProjects']
			},
			deliverableCount (state, getters) {
			  return getters[this.namespace + 'deliverableCount']
			},
			allSocialCampaigns (state, getters) {
			  return getters[this.namespace + 'allSocialCampaigns']
			},
			allSocialSeries (state, getters) {
			  return getters[this.namespace + 'allSocialSeries']
			},
			getDeliverableTemplateSlug (state, getters) {
			  return getters['getDeliverableTemplateSlug']
			},
			editDeliverableModal (state, getters) {
			  return getters[this.namespace + 'editDeliverableModal']
			},
			addContactModal (state, getters) {
			  return getters[this.namespace + 'addContactModal']
			},
			editContactModal (state, getters) {
			  return getters[this.namespace + 'editContactModal']
			},
			editSpokespersonModal (state, getters) {
			  return getters[this.namespace + 'editSpokespersonModal']
			},
			editWhoModal (state, getters) {
			  return getters[this.namespace + 'editWhoModal']
			},
		}),
		deliverableListIcon() {
			if (this.deliverableFilter.deliverableType && typeof (this.deliverableFilter.deliverableType[0]) == 'undefined') {
				if (typeof this.deliverableFilter.deliverableType.id != 'undefined' && this.deliverableFilter.deliverableType.id != 'all') {
					return this.deliverableFilter.deliverableType.id.replaceAll('_', '-');
				} else {
					return 'media-call';
				}
			} else {
				return 'media-call';
			}
		},
		deliverablesArray() {
			if (this.myWeek) {
				return this.userDeliverables
			} else {
				if (this.inProject) {
					return this.projectDeliverables;
				} else {
					return this.allDeliverables;
				}
			}
		},
		_() {
			return _;
		},


		// Hardcode
		presetViewsMyWeek() {
			return [
				{
					id: 'p1',
					createdTime: null,
					title: "Today",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted", "weekFilterOptions": {
						"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p2',
					createdTime: null,
					title: "This Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().startOf('week').toISOString()}","endDate":"${this.$moment().endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted", "weekFilterOptions": {
						"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p3',
					createdTime: null,
					title: "Next Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().add(1, 'week').startOf('week').toISOString()}","endDate":"${this.$moment().add(1, 'week').endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted", "weekFilterOptions": {
						"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p4',
					createdTime: null,
					title: "No Deadline",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"filterNoTaskDueDate":true,"noDepartment":"not_accepted","noCoordinator":"not_accepted", "weekFilterOptions": {
						"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p5',
					createdTime: null,
					title: "Overdue",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"","endDate":"${this.$moment().add(-1, 'day').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted", "weekFilterOptions": {
						"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]
		},
		presetViewsDashboard() {
			const filterForMyWeek = this.presetViewsMyWeek;
			const filterForDashboard =
			[
				{
					id: 'p101',
					createdTime: null,
					title: "Open Deliverables",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCreatedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCompletedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"status":[{"name":"Pending Completion","color":"var(--wf-pending-completion)"},{"name":"Not Started","color":"var(--wf-not-started)"},{"name":"In Progress","color":"var(--wf-in-progress)"},{"name":"Awaiting Approval","color":"var(--wf-awaiting-approval)"}],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":false,"filterNoDueDate":false,"noDepartment":"not_accepted", "weekFilterOptions": {
            "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]

			return filterForDashboard.concat(filterForMyWeek);
		},

		userViewsDeliverable() {
			return _.filter(this.userViews, { view_type: "deliverable" });
		},
	},
	methods: {
		...mapActions({
			fetchDeliverableUnreadMessageCount(dispatch, payload) {
				return dispatch("fetchDeliverableUnreadMessageCount", payload)
			},
			fetchUserDeliverableUnreadMessageCount(dispatch, payload) {
				return dispatch("fetchUserDeliverableUnreadMessageCount", payload)
			},
			fetchSystemSettings(dispatch, payload) {
				return dispatch("fetchSystemSettings", payload)
			},
		  fetchDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverables', payload)
		  },
		  createTag (dispatch, payload) {
		    return dispatch(this.namespace + 'createTag', payload)
		  },
		  fetchUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUsers', payload)
		  },
		  fetchActiveUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveUsers', payload)
		  },
		  fetchContacts (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchContacts', payload)
		  },
		  updateFieldValue (dispatch, payload) {
		    return dispatch(this.namespace + 'updateFieldValue', payload)
		  },
		  fetchDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDepartments', payload)
		  },
		  fetchActiveDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveDepartments', payload)
		  },
		  fetchSubjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchSubjects', payload)
		  },
		  fetchTags (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchTags', payload)
		  },
		  fetchGeoData (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchGeoData', payload)
		  },
		  fetchAllCustomFields (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchAllCustomFields', payload)
		  },
		  filterDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'filterDeliverables', payload)
		  },
		  fetchViews (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchViews', payload)
		  },
		  fetchProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchProjects', payload)
		  },
		  getDeliverableTypes (dispatch, payload) {
		    return dispatch(this.namespace + 'getDeliverableTypes', payload)
		  },
		  fetchUserManageProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
		  },
		  fetchDeliverableCount (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverableCount', payload)
		  },
		  fetchSocialSeries (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchSocialSeries', payload)
		  },
		  fetchSocialCampaigns (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchSocialCampaigns', payload)
		  },
		  fetchUserManageSocialCampaigns (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUserManageSocialCampaigns', payload)
		  },

		}),
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		}),
		getDeliverablePageTitle() {
			let returnData = '';
			let totalOutletCount = this.outletCount ? this.outletCount : 0;
			let totalDeliverableCount = this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0;
			if (typeof this.deliverableFilter.deliverableType == 'undefined') {
				return 'Deliverables' + '<span class="text-muted">(' + totalDeliverableCount + ' deliverables, ' + totalOutletCount + ' calls)</span>'
			}
			if ((typeof this.deliverableFilter.deliverableType.name != 'undefined' && typeof (this.deliverableFilter.deliverableType[0]) == 'undefined') && this.deliverableFilter.deliverableType.name != 'All') {
				returnData = this.deliverableFilter.deliverableType.name;
			} else {
				returnData = 'Deliverables';
			}
			return returnData + '<span class="text-muted">(' + totalDeliverableCount + ' deliverables, ' + totalOutletCount + ' calls)</span>';
		},
		deliverableTypeTitle(deliverableTypeId) {
			if (this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, { typeId: deliverableTypeId });
				if (typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit('resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function () {
				if (typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if (this.$router.currentRoute.name == 'dashboard') {
				if (localStorage.getItem('dashboardActiveSave')) {
					this.activeView = localStorage.getItem('dashboardActiveSave');
					this.viewBtnLabel = localStorage.getItem('dashboardActiveSaveTitle');
					this.currentViewData = localStorage.getItem('dashboardActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView = '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if (this.$router.currentRoute.name == 'myWeek') {
				if (localStorage.getItem('myWeekActiveSave')) {
					this.activeView = localStorage.getItem('myWeekActiveSave');
					this.viewBtnLabel = localStorage.getItem('myWeekActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myWeekActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView = '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if (this.$router.currentRoute.name == 'mediaCallPage') {
				if (localStorage.getItem('mediaCallActiveSave')) {
					this.activeView = localStorage.getItem('mediaCallActiveSave');
					this.viewBtnLabel = localStorage.getItem('mediaCallActiveSaveTitle');
					this.currentViewData = localStorage.getItem('mediaCallActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView = '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}

			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		removeView(viewId) {
			if (this.$router.currentRoute.name == 'dashboard') {
				if (viewId == localStorage.getItem('dashboardActiveSave')) {
					this.resetView();
				}
			} else if (this.$router.currentRoute.name == 'myWeek') {
				if (viewId == localStorage.getItem('myWeekActiveSave')) {
					this.resetView();
				}
			} else if (this.$router.currentRoute.name == 'mediaCallPage') {
				if (viewId == localStorage.getItem('mediaCallActiveSave')) {
					this.resetView();
				}
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("dashboardActiveSave");
			localStorage.removeItem("myWeekActiveSave");
			localStorage.removeItem("dashboardActiveSaveTitle");
			localStorage.removeItem("myWeekActiveSaveTitle");
			localStorage.removeItem("mediaCallActiveSave");
			localStorage.removeItem("mediaCallActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			if (this.$router.currentRoute.name == 'dashboard') {
				this.activeView = index;
				localStorage.setItem('dashboardActiveSave', index);
				localStorage.setItem('dashboardActiveSaveTitle', viewData.title);
				localStorage.setItem('dashboardActiveSaveData', viewData.saved_data);
			} else if (this.$router.currentRoute.name == 'myWeek') {
				this.activeView = index;
				localStorage.setItem('myWeekActiveSave', index);
				localStorage.setItem('myWeekActiveSaveTitle', viewData.title);
				localStorage.setItem('myWeekActiveSaveData', viewData.saved_data);
			} else if (this.$router.currentRoute.name == 'mediaCallPage') {
				this.activeView = index;
				localStorage.setItem('mediaCallActiveSave', index);
				localStorage.setItem('mediaCallActiveSaveTitle', viewData.title);
				localStorage.setItem('mediaCallActiveSaveData', viewData.saved_data);
			}
			if (this.$router.currentRoute.name == 'dashboard') {
				this.$store.commit(this.namespace + 'setDashboardDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.deliverableFilter);
				// this.filterQuery = this.deliverableFilter;
			} else if (this.$router.currentRoute.name == 'myWeek') {
				this.$store.commit(this.namespace + 'setMyWeekDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.myWeekDeliverableFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			} else if (this.$router.currentRoute.name == 'mediaCallPage') {
				this.$store.commit(this.namespace + 'setMediaCallFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.mediaCallFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			}
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			if (this.$router.currentRoute.name == "dashboard") {
				view = this.deliverableFilter;
			} else if (this.$router.currentRoute.name == "myWeek") {
				view = this.myWeekDeliverableFilter;
			} else if (this.$router.currentRoute.name == "mediaCallPage") {
				view = this.mediaCallFilter;
			}
			let viewData = {
				title: this.viewBtnLabel,
				filterQuery: view,
				viewId: this.activeView
			};
			let that = this;
			this.$store.dispatch(this.namespace + "saveView", viewData).then(function () {
				if (that.$router.currentRoute.name == 'dashboard') {
					localStorage.setItem('dashboardActiveSaveData', JSON.stringify(view));
				} else if (that.$router.currentRoute.name == 'myWeek') {
					localStorage.setItem('myWeekActiveSaveData', JSON.stringify(view));
				} else if (that.$router.currentRoute.name == 'mediaCallPage') {
					localStorage.setItem('mediaCallActiveSaveData', JSON.stringify(view));
				}
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		setPriority(deliverable, isMobile) {
			let priority;
			if (isMobile) {
				priority = $('.mobile-deli-info .listing-priority-del-' + deliverable.id + ' .vue-star-rate ul.list li.active').length;
			} else {
				priority = $('.data-items.hide-mobile .listing-priority-del-' + deliverable.id + ' .vue-star-rate ul.list li.active').length;
			}
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		editSocialModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		hasMyWeek() {
			if (this.userDeliverables) {
				if (this.userDeliverables.overdue.length > 0 ||
					this.userDeliverables.today.length > 0 ||
					this.userDeliverables.thisWeek.length > 0 ||
					this.userDeliverables.nextWeek.length > 0 ||
					this.userDeliverables.upcoming.length > 0 ||
					this.userDeliverables.noDeadline.length > 0 ||
					this.userDeliverables.projectOnHold.length > 0
					// || this.userDeliverables.completed.length > 0
				) {
					return true;
				}
			}
			return false;
		},
		createNewDeliverable() {
			let type = 'media_call';
			if (this.deliverableFilter.deliverableType && typeof (this.deliverableFilter.deliverableType[0]) == 'undefined') {
				type = this.deliverableFilter.deliverableType.id;
			}
			this.$store
				.dispatch(this.namespace + "createNewDeliverable", { type })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if (!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editDeliverableModal");
					this.$nextTick(() => {
						$('.edit-deliverable-modal .deliverable-title').trigger('click');
					})
					this.$store.dispatch(this.namespace + "fetchDeliverables")
					this.fetchDeliverableCount();
				});
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.setDataLoading(true);
			this.fetchDeliverableCount();
			this.fetchDeliverables(data).then(() => {
				this.setDataLoading(false);
			});
		},

		isSocialMedia(deliverable) {
			if (parseInt(deliverable.deliverable_template_id) === parseInt(process.env.MIX_APP_DELIVERABLE_TEMPLATE_SOCIAL_MEDIA)) {
				return true;
			}
			return false;
		},
		showModalFn(deliverable, openToChatTab) {
			this.setDataLoading(true);
			// shows edit deliverable modal
			let deliverableId = deliverable.id;
			let modalId = "editDeliverableModal";

			let template_slug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (template_slug == "social-media") {
				modalId = "editSocialModal";
				if(deliverable.social_series){
					if(deliverable.social_series.length && !deliverable.manually_updated_at){
						deliverableId = this.getSeriesMasterByDeliverable(deliverable);
					}
				}
			} else {
				// Show Chat in only editDeliverableModal
				const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
				if (
					openToChatTab == true &&
					(
						deliverableTemplateSlug == "marketing-project" ||
						deliverableTemplateSlug == "media-call" ||
						deliverableTemplateSlug == "media-event" ||
						deliverableTemplateSlug == "news-release" ||
						deliverableTemplateSlug == "writing-assignment"
					)
				) {
					// openToChatTab == true, clicked on unread message count chat bubble icon
					// Contact is tab1, Chat is tab2
					this.tabIndex = 1;
				} else {
					this.tabIndex = 0;
				}
			}

			if (template_slug == "organic-social-media-plan") {
				modalId = "editOrganicSocialMediaPlanModal";
				if (deliverable.social_series) {
					if (deliverable.social_series.length && !deliverable.manually_updated_at) {
						deliverableId = this.getSeriesMasterByDeliverable(deliverable);
					}
				}
			}

			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if (!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show(modalId);
					this.setDataLoading(false);
				});

		},

		pushRoute() {
			if (this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if (this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({ name: 'dashboard' });
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		},

		hasPriorityField(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		showInfoCol(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		infoColStyle(deliverable) {
			// Unused for now
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "project-deliverable";
		},
		showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

		// Status toggle from the header
		toggleStatusView(expandAll) {
			if (this.isMobile()) {
				if (expandAll) {
					$('.deliverable-status-overview').hide();
					$('.deliverable-dates').css('padding-top', 0);
				} else {
					$('.deliverable-status-overview').show();
					$('.deliverable-dates').css('padding-top', '15px');
				}
			}
			this.$emit("collapseToggleUpdated", expandAll);
		},

		calculateStartDate(deliverable) {
			let latestDueDate = null;

			let start_date = _.filter(deliverable.customFields, { field_key: 'start_date' });
			if (start_date.length > 0) {
				return start_date[0].value;
			}
			let start_datetime = _.filter(deliverable.customFields, { field_key: 'start_datetime' });
			if (start_datetime.length > 0) {
				return start_datetime[0].value;
			}


			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || dueDateField.value < latestDueDate )) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},

		calculateEndDateLabel(deliverable) {
			let label = "END DATE:";
			let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
			if (publish_datetime.length > 0) {
				return "PUBLISH:";
			}
		},


		calculateEndDate(deliverable) {
			let latestDueDate = null;

			let end_date = _.filter(deliverable.customFields, { field_key: 'end_date' });
			if (end_date.length > 0) {
				return end_date[0].value;
			}
			let end_datetime = _.filter(deliverable.customFields, { field_key: 'end_datetime' });
			if (end_datetime.length > 0) {
				return end_datetime[0].value;
			}
			let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
			if (publish_datetime.length > 0) {
				return publish_datetime[0].value;
			}

			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},

		closeVuewSelectModal() {
			this.$bvModal.hide("headerViewSelectModal");
		},

		userCanEditDeliverable() {
			return (this.userAbilities.deleteMediaCall);
		},

		deleteDeliverableClick(deliverable) {
			// deliverable.deleteClicked = true;
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.$bvModal.show("deleteDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteDeliverableConfirmModal");
				}
			}
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},
		onConfirmRemoveDeliverable() {
			if (this.showRemoveDeliverableId) {
				let that = this;
				let deliverable = null;
				if (this.deliverablesArray instanceof Array) {
					deliverable = this.deliverablesArray.find(x => x.id == this.showRemoveDeliverableId);
				} else {
					for (let i of Object.keys(this.deliverablesArray)) {
						deliverable = this.deliverablesArray[i].find(x => x.id == this.showRemoveDeliverableId);
						if (deliverable != null) break;
					}
				}
				const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId: this.showRemoveDeliverableId }).then(function (response) {
					that.$bvModal.hide("deleteDeliverableConfirmModal");
					// TODO: removing a deliverable should only remove it from the list, not replace entire list.
					// that.$store.commit(this.namespace + 'removeMediaCallFromList', deliverableId);
					// that.$store.dispatch(that.namespace + 'countOutlets');

					that.showRemoveDeliverableId = null;
					if (response && response?.status && response?.status != 200) {
						return;
					}
					that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function () {
						toast.hide();

						if (deliverableTemplateSlug == "media-call") {
							that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Media call deleted.');
						} else {
							that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');
						}

						that.$store.dispatch(that.namespace + 'fetchProjectDeliverable');
					});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		getSeriesMasterByDeliverable(deliverable) {
			if (typeof deliverable.social_series_deliverables != "undefined") {
				let series = deliverable.social_series_deliverables;
				if (series.length) {
					let master = series.find(x => x.is_master === 1);
					if (master) {
						return master.id;
					}
				}
			}
			return false;
		},
		isSeriesMaster(deliverable) {
			if (typeof deliverable.social_series_deliverables != "undefined") {
				let series = deliverable.social_series_deliverables;
				if (series && series?.length) {
					let master = series.find(x => x.is_master === 1);
					if (master) {
						if (master.id === deliverable.id) {
							return true;
						}
					}
				}
			}
			return false;
		},
		getSeriesNameByDeliverable(deliverable) {
			if (this.allSocialSeries.length && deliverable.social_series.length) {
				let series = this.allSocialSeries.find(x => x.id === deliverable.social_series[0]);
				if (series) {
					return series.name;
				}
			}
			return "None";
		},
		displaySocialPublishDate(publishDate) {
			if (publishDate) {
				return this.$moment.utc(publishDate).local().format("DD MMM, YYYY");
			}
			return "NO DATE SET";
		},
		getPublishStatusStyle(publish_status) {
			if (publish_status) {
				var status = JSON.parse(publish_status);
				return "background-color:" + status.color;
			}
		},
		updateDeliverableTags(updatedDeliverableId) {
			let deliverableToUpdate;
			if (this.deliverablesArray instanceof Array) {
				deliverableToUpdate = this.deliverablesArray.find(x => x.id == updatedDeliverableId);
			} else {
				for (let i of Object.keys(this.deliverablesArray)) {
					deliverableToUpdate = this.deliverablesArray[i].find(x => x.id == updatedDeliverableId);
					if (deliverableToUpdate != null) break;
				}
			}
			if (deliverableToUpdate != null) {
				deliverableToUpdate.tags = this.deliverableDetail.tags;
			} else {
				console.error(`List Deliverable with ID ${updatedDeliverableId} not found.`);
			}
		},
		isParentProjectOnHold(project_id) {
			if (
				project_id &&
				project_id.project_status &&
				project_id.project_status.slug &&
				project_id.project_status.slug == 'on-hold'
			) {
				return true;
			}
			return false;
		},
		applyBackgroundColorIfOnHold(project_id) {
			if (
				project_id &&
				project_id.project_status &&
				project_id.project_status.color &&
				project_id.project_status.slug &&
				project_id.project_status.slug == 'on-hold'
			) {
				return { backgroundColor: project_id.project_status.color };
			}
			return {};
		},
	},
	beforeUpdate() {
		if (this.activeView != '-1' && ((typeof this.activeView).toLowerCase() == "string" ? !this.activeView.startsWith('p') : true)) {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if (!$('.deliverable-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');

			if (this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if ($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}

		this.viewModalShowCreateView = !$('.save-view').hasClass('d-none');
		this.viewModalShowUpdateView = !$('.update-view').hasClass('d-none');
	},
	mounted() {
		let that = this;

		this.$root.$on('updateListTitle', function (title) {
			that.listTitle = title;
		});
		this.setActiveView();

		this.$root.$on('hideUpdateText', function () {
			that.showUpdateViewText = false;
		});
		this.$root.$on('resetView', function () {
			that.resetView();
		});
		this.$root.$on('showUpdateViewText', function (payload) {
			if (that.$router.currentRoute.name != 'myWeek' && that.$router.currentRoute.name != 'dashboard' && that.$router.currentRoute.name != 'mediaCallPage') return;

			let currentFilter = payload.currentFilter
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;

			if (!payload.isFilterActive) {
				that.activeView = '-1'
				that.viewBtnLabel = 'Views'
			}

			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if (typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if (tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if (typeof tempJson2[key] != 'undefined'
						&& excludedKeys.indexOf(key) == -1) {
						if (key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted'
							};
							if (tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if ((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
										that.activeView = -1;
									} else {
										that.showUpdateViewText = true;
									}
									return;
								}
							}
						} else {
							if (JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
									that.activeView = -1;
								} else {
									that.showUpdateViewText = true;
								}
								return;
							}
						}
					}
				});
			}
		});

		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
						this.$store.commit(this.namespace + "setDeliverable", e.deliverable);
						this.$store.commit(this.namespace + "setDeliverableDetail", e.deliverable);
					}
				}
			}
		});
		Echo.channel('deliverable').listen('DeliverableContactsUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				this.$store.commit(this.namespace + "setDeliverableContacts", { contacts: e.contacts, deliverableId: e.deliverableId });
			}
		});
		Echo.channel('task').listen('TaskUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {

					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								this.$store.commit(this.namespace + "setTask", { task: e.task, deliverableId: e.deliverableId });
							}
						}
					}
				}
			}
		});
		this.$root.$on('bv::modal::hide', function (bvEvent, modalId) {
			if (modalId == 'editDeliverableModal' && that.$router.currentRoute.name == 'myWeek') {
				that.sortTasks({ sortKey: false, deliverables: that.deliverablesArray, sortFields: true })
			}

			if (modalId == "editDeliverableModal" || modalId == "editSocialModal") {
				this.$store.state.deliverables.editDeliverableModal = false;
				let currentTitle = document.title.match(/\(\d+\)\s/g);
				if (!currentTitle) {
					document.title = process.env.MIX_APP_NAME;
				} else {
					document.title = currentTitle[0] + process.env.MIX_APP_NAME;
				}
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
		});

		if (this.$router.currentRoute.path.indexOf('/deliverable/') != -1) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			this.$store.dispatch(this.namespace + 'getDeliverableDetail', { deliverableId: deliverableId }).then(function () {
				let deliverable = that.deliverableDetail;

				let template_slug = that.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
				if (template_slug == "social-media") {
					that.$bvModal.show('editSocialModal');
				} else if (template_slug == "organic-social-media-plan") {
					that.$bvModal.show('editOrganicSocialMediaPlanModal');
				} else {
					that.$bvModal.show('editDeliverableModal');
				}
			});
		}

		// fetch user manage projects
		this.fetchUserManageProjects();
	},
	watch: {
		'$route': function (to, from) {
			if (to.path.indexOf('deliverable/') != -1) {
				let deliverableId = to.path.split('/')[2],
					that = this;
				this.$store.dispatch(this.namespace + 'getDeliverableDetail', { deliverableId: deliverableId }).then(function () {
					that.$bvModal.show('editDeliverableModal');
				});
			}
		},
		userDeliverables: {
			handler(newItems, oldItems) {
				if (this.dataLoading) {
					// fetchDeliverables has completed, dataLoading = false, 
					// call count api only once after userDeliverables array has value
					if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
						// Call api when userDeliverables or userDeliverables properties change
						if (newItems.length > 0) {
							this.fetchUserDeliverableUnreadMessageCount();
						}
					}
				}
			},
			deep: true
		},
		allDeliverables: {
			handler(newItems, oldItems) {
				if (this.dataLoading) {
					// fetchDeliverables has completed, dataLoading = false, 
					// call count api only once after allDeliverables array has value
					if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
						// Call api when userDeliverables or userDeliverables properties change
						if (newItems.length > 0) {
							this.fetchDeliverableUnreadMessageCount();
						}
					}
				}
			},
			deep: true
		},
	}
};
</script>
